import { render, staticRenderFns } from "./Cm-feed-one.vue?vue&type=template&id=9c082864&scoped=true"
import script from "./Cm-feed-one.vue?vue&type=script&lang=js"
export * from "./Cm-feed-one.vue?vue&type=script&lang=js"
import style0 from "./Cm-feed-one.vue?vue&type=style&index=0&id=9c082864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c082864",
  null
  
)

export default component.exports